export default "__VITE_ASSET__BEqps2Oc__"